import React, { useEffect, useState } from "react";
import PurchaseFullDetails from "./PurchaseFullDetails";
import axios from "axios";
import { MyGlobalContext } from "../../Context";
import { toast } from "react-toastify";

const styleToast = {
  position: "top-center",
  autoClose: 2000,
};
const PurchaseProfile = () => {
  const {
    isCheckDetails,
    setCheckDetails,
    token,
    purchaseData,
    setPurchaseData,
  } = MyGlobalContext();
  const [checkId, setCheckId] = useState(null);
  const [isDeleted, setIsDeleted] = useState("");

  const DeleteHistory = () => {
    axios
      .post(
        "https://cocktailshop.onrender.com/purchase/history/delete",
        {},
        {
          headers: { Authorization: token },
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res.status === 201) {
          setIsDeleted(res.data.message);
        }
      })
      .catch((err) => {
        const status = err.response.status;
        const message = err.response.data.message;
        if (status === 500) {
          toast.warn(message, styleToast);
        } else if (status === 404) {
          toast.warn(message, styleToast);
        } else {
          toast.warn(message, styleToast);
        }
      });
  };

  const GetPurchaseData = () => {
    axios
      .get("https://cocktailshop.onrender.com/get/purchase/details", {
        headers: { Authorization: token },
        withCredentials: true,
      })
      .then((res) => {
        if (res.status === 200) {
          setPurchaseData(res.data.history);
        }
      })
      .catch((err) => {
        const status = err.response.status;
        const message = err.response.data.message;
        if (status === 500) {
          toast.warn(message, styleToast);
        } else if (status === 404) {
          toast.warn(message, styleToast);
        }
      });
  };
  useEffect(() => {
    GetPurchaseData();
  }, [isDeleted]);
  return (
    <div className="table-small-device pb-10">
      <h1 className="text-center mt-5">Purchase History</h1>
      <div className=" w-24 h-1 bg-blue-700 mx-auto rounded-lg"></div>
      {purchaseData?.purchaseHistory.length === 0 ? (
        <h1 className="text-center pt-3 capitalize ">
          No purchase data found, nothing to show!
        </h1>
      ) : (
        <div>
          <table className="mx-auto mt-10 mb-4 md:min-w-[700px] border-2 border-slate-100">
            <thead className="bg-[black]  text-white w-[100%]">
              <tr>
                <td>Time of Purchase</td>
                <td>Total Price($)</td>
                <td>Total Item</td>
                <td>Details</td>
              </tr>
            </thead>
            <tbody>
              {purchaseData?.purchaseHistory.map((history) => {
                const { _id: id, createdAt, totalPrice, totalItem } = history;
                const date = new Date(createdAt).toLocaleDateString();
                const time = new Date(createdAt).toLocaleTimeString();
                return (
                  <tr key={id}>
                    <td>{`${date} ${time}`}</td>
                    <td>{totalPrice}</td>
                    <td>{totalItem}</td>
                    <td
                      onClick={() => {
                        setCheckDetails(true);
                        setCheckId(id);
                      }}
                      className="checkDetails"
                    >
                      Check
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <button onClick={DeleteHistory} className="block mx-auto border-2 px-[20px] py-[2px] rounded-md shadow-2xl btn-clear-history">
            Clear Purchase History
          </button>
        </div>
      )}
      {isCheckDetails && checkId !== null && (
        <PurchaseFullDetails checkId={checkId} />
      )}
    </div>
  );
};

export default PurchaseProfile;
